"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializePlugin = void 0;
const common_1 = require("../common");
class InitializePlugin {
    execute(list, activities, _groups, _conditions, selected) {
        list = activities.map((activity) => {
            const disabled = common_1.ImmutableStatuses.includes(activity.activity_participant_status);
            return {
                ...activity,
                disabled: disabled,
                registered: selected.includes(activity.id) || disabled,
            };
        });
        return list.sort(this._compareInterval);
    }
    _compareInterval(a, b) {
        if (a.start.getTime() !== b.start.getTime()) {
            return a.start.getTime() < b.start.getTime() ? -1 : 1;
        }
        const aName = (a.name || '').toLowerCase();
        const bName = (b.name || '').toLowerCase();
        return aName < bName ? -1 : 1;
    }
}
exports.InitializePlugin = InitializePlugin;
